import { VolumetricsReviewDataModel } from "../Types/Product/VolumetricsReviewDataModel"

export interface IFoodVolumetricsReviewFieldMessages extends Partial<Record<keyof VolumetricsReviewDataModel, string>> {}

interface IFoodVolumetricsReviewError extends IFoodVolumetricsReviewFieldMessages {}
export type { IFoodVolumetricsReviewError as FoodVolumetricsReviewError }
interface IFoodVolumetricsReviewWarning extends IFoodVolumetricsReviewFieldMessages {}
export type { IFoodVolumetricsReviewWarning as FoodVolumetricsReviewWarning }

export interface IFoodVolumetricsReviewType {
    values: VolumetricsReviewDataModel
    errors: IFoodVolumetricsReviewError
    warnings: IFoodVolumetricsReviewWarning
    submitted: boolean
    dirty: boolean
    setPopup: boolean
    isFormValid: boolean
}

const emptyFieldMessages: IFoodVolumetricsReviewFieldMessages = {
    dcp: undefined,
    originalRowNumber: undefined,
    superCatDesc: undefined,
    deptCode: undefined,
    commCode: undefined,
    packSize: undefined,
    skuNo: undefined,
    suppCode: undefined,
    suppName: undefined,
    officeDesc: undefined,
    desc: undefined,
    breakPack: undefined,
    caseLengthMm: undefined,
    caseWidthMm: undefined,
    caseHeightMm: undefined,
    caseWeightKg: undefined,
    weightUom: undefined,
    casesPerLayer: undefined,
    layersPerPallet: undefined,
    casesPerPallet: undefined,
    rejectionReason: undefined,
    fileName: undefined,
    uploadDate: undefined,
    status: undefined,
    overridenValidations: undefined
}

export const initialStateFoodVolumetricsReviewType: IFoodVolumetricsReviewType = {
    values: {
        dcp: "",
        originalRowNumber: 0,
        superCatDesc: "",
        deptCode: null,
        commCode: null,
        packSize: null,
        skuNo: "",
        suppCode: "",
        suppName: "",
        officeDesc: "",
        desc: "",
        breakPack: "",
        caseLengthMm: null,
        caseWidthMm: null,
        caseHeightMm: null,
        caseWeightKg: null,
        weightUom: "",
        casesPerLayer: null,
        layersPerPallet: null,
        casesPerPallet: null,
        rejectionReason: "",
        fileName: "",
        uploadDate: "",
        status: "",
        overridenValidations: false
    },
    errors: { ...emptyFieldMessages },
    warnings: { ...emptyFieldMessages },
    dirty: false,
    isFormValid: false,
    submitted: false,
    setPopup: false
}